const home = {
  hero: {
    pillBadge: "Führende Zahnklinik in Bulgarien",
    title: {
      prefix: "Lächeln verwandeln,",
      emphasis: "Leben verändern",
    },
    description:
      "Erleben Sie erstklassige Zahnmedizin mit unserem Team aus hochqualifizierten Fachleuten. Wir kombinieren fortschrittliche Technologie mit persönlichen Behandlungsplänen, um Ihnen das perfekte Lächeln zu schenken, das Sie verdienen.",
    ctas: {
      primary: "Termin vereinbaren",
      secondary: "Leistungen entdecken",
    },
    specialOffer: {
      guaranteeLabel: "JAHRE GARANTIE",
      price: "2300 €",
      priceLabel: "All-on-4",
      bullets: [
        "Premium-Qualität",
        "Komplettlösung",
        "Expertenbehandlung",
        "Kostenlose Beratung",
      ],
    },
    floatingStats: {
      experience: { small: "Jahre", large: "Erfahrung" },
      patients: { small: "Zufriedene", large: "Patienten" },
    },
  },
  about: {
    title: "ÜBER UNS",
    description: "Engagiert für außergewöhnliche Zahnpflege mit sanfter Hand",
    imageAlt: "Elite Dental Solutions x-ray technology",
    badges: ["Fortschrittliche Technologie", "Expertenteam"],
    paragraphs: [
      "Willkommen bei Elite Dental Solutions, einer führenden Zahnklinik mit Sitz in Sofia, Bulgarien. Unser Team aus hocherfahrenen und qualifizierten Zahnärzten und Zahntechnikern mit über 10 Jahren Expertise widmet sich der außergewöhnlichen zahnmedizinischen Versorgung von lokalen und internationalen Patienten.",
      "Wir sind stolz darauf, die neuesten Fortschritte in der Zahntechnologie zu nutzen, um unseren Patienten die bestmögliche Pflege zu bieten. Mit über 50 Zertifizierungen und umfangreicher Erfahrung in der Arbeit mit internationalen Patienten bieten wir ein umfassendes Spektrum an zahnärztlichen Leistungen an, um Ihre Bedürfnisse zu erfüllen und Ihnen zu einem schönen Lächeln zu verhelfen.",
    ],
    checkBullets: [
      "Modernste zahnmedizinische Ausstattung und Technologie",
      "Mehrsprachiges Personal für internationale Patienten",
      "Individuelle Behandlungspläne für jeden Patienten",
      "Umfassende Dienstleistungen im Zahntourismus",
    ],
    cta: "Beratungstermin vereinbaren",
    stats: [
      {
        value: "10+",
        title: "Jahre Erfahrung",
        description: "Über ein Jahrzehnt außergewöhnliche Zahnpflege",
      },
      {
        value: "5000+",
        title: "Lächelnde Patienten",
        description: "Zufriedene Patienten aus der ganzen Welt",
      },
      {
        value: "20+",
        title: "Meister-Zertifizierungen",
        description: "Hochqualifizierte Zahnmedizin-Profis",
      },
      {
        value: "12+",
        title: "Zufriedene Mitarbeiter",
        description: "Engagiertes Team von Zahnexperten",
      },
    ],
  },
  services: {
    heading: "UNSERE LEISTUNGEN",
    description: "Umfassende Zahnversorgung mit sanfter Hand und persönlichem Ansatz",
    learnMore: "Mehr erfahren",
    contactCta: "Mehr erfahren",
    items: {
      implantology: {
        title: "IMPLANTOLOGIE",
        description:
          "Unsere Zahnarztpraxis bietet hochwertigen, langlebigen Zahnersatz, der ein natürliches Aussehen und Gefühl garantiert, sich perfekt in Ihre natürlichen Zähne einfügt und Ihre allgemeine Mundgesundheit erheblich verbessert.",
        imageAlt: "Implantology",
      },
      endodontics: {
        title: "ENDODONTIE",
        description:
          "In unserer Praxis wenden wir patientenfreundliche Verfahren zur Wurzelbehandlung an. Dadurch minimieren wir Beschwerden für den Patienten und erhalten die natürliche Schönheit Ihres Lächelns, während wir beschädigte oder infizierte Zähne reparieren und ihre Funktion und Gesundheit wiederherstellen.",
        imageAlt: "Endodontics",
      },
      "oral-surgery": {
        title: "ORALCHIRURGIE",
        description:
          "Unsere Klinik bietet minimalinvasive Extraktionen sowie umfassende Therapien für eine Reihe von Gesichts- und Zahnproblemen an, wobei der Schwerpunkt auf der Wiederherstellung der Mundgesundheit, dem Patientenkomfort und der Ästhetik liegt.",
        imageAlt: "Oral Surgery",
      },
      periodontology: {
        title: "PARODONTOLOGIE",
        description:
          "Unsere Klinik bietet spezialisierte Zahnfleischbehandlungen und -pflege an, mit Fokus auf Prävention, Diagnose und Behandlung von Parodontalerkrankungen zur Verbesserung der Mundgesundheit und des allgemeinen Wohlbefindens.",
        imageAlt: "Periodontology",
      },
      orthodontics: {
        title: "KIEFERORTHOPÄDIE",
        description:
          "In unserer Klinik stehen Expertenbehandlungen für Zahnfehlstellungen zur Verfügung. Wir wenden modernste Methoden an und jeder Behandlungsplan wird individuell angepasst, um das bestmögliche Ergebnis für unsere Patienten zu garantieren – und so sowohl ihr allgemeines Erscheinungsbild als auch ihre Mundgesundheit zu verbessern.",
        imageAlt: "Orthodontics",
      },
      bonding: {
        title: "BONDING (ZAHNÄSTHETIK)",
        description:
          "In unserer Praxis tragen wir fachmännisch zahnfarbenes Komposit auf die Zähne auf, um deren Aussehen zu verbessern. Für ein nahtloses, optisch schönes Ergebnis, das Ihr Selbstvertrauen und Ihr Lächeln stärkt, passen wir das Material exakt an die Farbe Ihrer natürlichen Zähne an.",
        imageAlt: "Bonding",
      },
      prosthetics: {
        title: "PROTHETIK",
        description:
          "Unser zahnmedizinisches Zentrum ist darauf spezialisiert, Lösungen für fehlende Zähne mittels maßgefertigter Brücken oder Prothesen anzubieten. Dieser Zahnersatz wird sorgfältig entworfen, um nicht nur die Funktion wiederherzustellen, sondern auch die Ästhetik Ihres Lächelns zu verschönern.",
        imageAlt: "Prosthetics",
      },
      cariesology: {
        title: "KARIESBEHANDLUNG",
        description:
          "Wir bieten vollständige Prävention und gezielte Behandlung von Karies, wobei wir Patientenaufklärung, Routineuntersuchungen und fortschrittliche Diagnostik integrieren, um eine effektive Pflege und langfristige Mundgesundheit zu gewährleisten.",
        imageAlt: "Cariesology",
      },
      "teeth-whitening": {
        title: "ZAHNAUFHELLUNG (BLEACHING)",
        description:
          "Erhalten Sie ein helleres, jugendlicheres Lächeln, während wir Verfärbungen und Flecken gekonnt von Ihren Zähnen entfernen. Unsere Behandlungen sind darauf ausgelegt, Ihre Zahnästhetik zu verbessern und ein strahlendes Lächeln zu liefern, das einen bleibenden Eindruck hinterlässt.",
        imageAlt: "Teeth Whitening",
      },
      "dental-tourism": {
        title: "ZAHNTOURISMUS",
        description:
          "Dolmetscher, Transport und Unterstützung bei der Unterkunft – buchen Sie einfach bei uns und unser engagiertes Team kümmert sich um jedes Detail und bietet eine reibungslose Erfahrung, die auf Ihre Bedürfnisse zugeschnitten ist.",
        imageAlt: "Dental Tourism",
      },
    },
  },
  testimonials: {
    heading: "ZUFRIEDENE PATIENTEN",
    subheading: "Sehen Sie, was unsere Patienten über ihre Erfahrungen mit uns sagen",
    google: {
      title: "Google Reviews",
      ratingValue: "5.0",
      countLabel: "(63 reviews)",
      readAll: "Alle Bewertungen lesen",
    },
    carousel: {
      prevAria: "Previous testimonial",
      nextAria: "Next testimonial",
    },
    metrics: {
      satisfaction: "Zufriedenheitsrate",
      positive: "Positive Bewertungen",
      countries: "Betreute Länder",
    },
    items: {
      google: {
        g1: {
          content:
            "Nothing short of perfect will do for this Clinic. Their attention to detail is second to none. The staff are so professional yet caring. English is widely spoken by all.",
          name: "Garry Gariside",
          timeAgo: "4 weeks ago",
          initial: "G",
        },
        g2: {
          content:
            "I had the immense pleasure of receiving treatment at Elite Dental Solutions under the care of Dr. Hadzhialish, and I couldn't be more thrilled with the results. I opted for the All-on-4 implant procedure, and from the very beginning, I felt in safe hands.",
          name: "Olen Sr12",
          timeAgo: "2 months ago",
          initial: "O",
        },
        g3: {
          content:
            "The clinic was immaculate. Doctors friendly and efficient. Very happy with the results. Couldn't have been looked after better.",
          name: "Loz Borg",
          timeAgo: "3 months ago",
          initial: "L",
        },
      },
      regular: {
        r1: {
          content:
            "I was nervous about getting dental implants, but the team at Elite Dental Solutions made the entire process smooth and stress-free. From my first consultation to the final result, they were professional, caring, and attentive. I now have a beautiful smile that I'm proud of, and I couldn't be happier with the outcome!",
          name: "Lynn M",
          location: "United Kingdom",
        },
        r2: {
          content:
            "I visited Elite Dental Solutions for teeth whitening before my wedding, and the results were incredible! The staff was so friendly, and they really took the time to explain the procedure to me. My teeth are several shades brighter, and I felt so confident on my big day. Thank you for making my smile picture-perfect!",
          name: "George L",
          location: "Germany",
        },
        r3: {
          content:
            "After years of dealing with tooth sensitivity and gum issues, I finally found the solution at Elite Dental Solutions. Their thorough approach to my treatment and the personalized care I received made all the difference. I can eat and smile without pain now, and I'm so grateful for their expertise and kindness.",
          name: "Alex D",
          location: "Italy",
        },
        r4: {
          content:
            "Having avoided dental work for years due to anxiety, I was amazed by how comfortable the team at Elite Dental Solutions made me feel. They were patient, understanding, and explained everything clearly. The quality of work is outstanding, and for the first time in my life, I don't dread going to the dentist!",
          name: "Sarah K",
          location: "France",
        },
        r5: {
          content:
            "As someone who traveled from abroad specifically for dental work, I couldn't be more impressed with Elite Dental Solutions. They arranged everything from airport pickup to accommodation recommendations. The dental work itself was top-notch, and the cost savings compared to my home country made the trip more than worthwhile.",
          name: "James W",
          location: "United States",
        },
      },
    },
  },
  gallery: {
    heading: "FOTOGALERIE",
    subheading: "Entdecken Sie unsere Sammlung wunderschöner Lächeln-Transformationen",
    closeAria: "Close gallery",
    prevAria: "Previous image",
    nextAria: "Next image",
    items: {
      i1: { alt: "Klinik – Elite Dental Solutions Klinik-Interieur", category: "Clinic" },
      i3: { alt: "Ausstattung – Modernste zahnmedizinische Geräte", category: "Equipment" },
      i4: { alt: "Ausstattung – Fortschrittliche Zahntechnologie", category: "Equipment" },
      i5: { alt: "Klinik – Beratungsraum", category: "Clinic" },
      i6: { alt: "Klinik – Empfangsbereich der Zahnklinik", category: "Clinic" },
      i7: { alt: "Technologie – Fortschrittliche Röntgen-Technologie", category: "Technology" },
      i8: { alt: "Klinik – Praxisumgebung", category: "Clinic" },
      i9: { alt: "Klinik – Moderne zahnmedizinische Einrichtungen", category: "Clinic" },
      i10: { alt: "Ausstattung – Fortschrittlicher Arbeitsplatz", category: "Equipment" },
      i11: { alt: "Ausstattung – Professionelles Behandlungs-Setup", category: "Equipment" },
      i12: { alt: "Klinik – Hochmoderne Zahnarztpraxis", category: "Clinic" },
    },
  },
  contact: {
    heading: "KONTAKTIEREN SIE UNS",
    subheading: "Wir sind hier, um Ihre Fragen zu beantworten und Ihnen bei der Terminplanung zu helfen",
    cardTitle: "Kontakt aufnehmen",
    labels: {
      phone: "Telefon",
      email: "E-Mail",
      address: "Adresse",
      workingHours: "Öffnungszeiten",
    },
    phone: { telHref: "+491793931622", display: "+49 179 393 1622" },
    email: { value: "info@elitedentalsolutions.eu" },
    address: {
      line1: "Manastirski Livadi, zh.k. Manastirski livadi B 65,",
      line2: "1404 Sofia, Bulgarien",
    },
    workingHours: {
      line1: "Montag - Freitag: 9:00 - 19:00",
      line2: "Samstag: Nach Vereinbarung",
    },
    stickyCallText: "Jetzt Anrufen",
    form: {
      title: "Kontaktieren Sie uns",
    },
  },
  contactForm: {
    fieldLabels: {
      firstName: "Vorname*",
      lastName: "Nachname*",
      email: "E-Mail*",
      phone: "Telefon*",
      message: "Nachricht*",
    },
    errors: {
      firstNameRequired: "First Name is required",
      lastNameRequired: "Last Name is required",
      emailRequired: "Email is required",
      emailInvalid: "Invalid email address",
      phoneRequired: "Phone number is required",
      phoneInvalid: "Invalid phone number",
    },
    toasts: {
      validationError: {
        title: "Validation Error",
        description: "Please fill in all required fields correctly.",
      },
      success: {
        title: "Message Sent!",
        description: "We'll get back to you as soon as possible.",
      },
      error: {
        title: "Error",
        description: "Failed to send message. Please try again later.",
      },
    },
    submit: {
      idle: "Absenden",
      loading: "Sending...",
    },
    privacy: {
      prefix: "Mit dem Absenden dieses Formulars stimmen Sie unserer",
      linkLabel: "Datenschutzrichtlinie",
      suffix: " zu.",
    },
  },
};

export default home;

